import React from 'react';
import ReactDOM from 'react-dom/client';
import AppWithProviders from './app-with-providers';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<AppWithProviders />);
